// SPDX-FileCopyrightText: 2017-2022 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

import styled from 'styled-components'

import { StaticChip } from 'lib-components/atoms/Chip'

export const OneLetterChip = styled(StaticChip)`
  padding: 4px 7px 4px 7px;
  font-size: 18px;
  font-weight: bold;
`
